import React from 'react'
import PropTypes from 'prop-types'
import AlertsContent from './AlertsContent'

const Alerts = props => <AlertsContent {...props} />

Alerts.propTypes = {
  collectId: PropTypes.number.isRequired,
  draftId: PropTypes.number,
  hasVariables: PropTypes.bool,
  isAdmin: PropTypes.bool.isRequired
}

Alerts.defaultProps = {
  draftId: null,
  hasVariables: false
}

export default Alerts
